import { render, staticRenderFns } from "./ProjectShapeSchemasList.vue?vue&type=template&id=0e222e98&scoped=true"
import script from "./ProjectShapeSchemasList.vue?vue&type=script&lang=js"
export * from "./ProjectShapeSchemasList.vue?vue&type=script&lang=js"
import style0 from "./ProjectShapeSchemasList.vue?vue&type=style&index=0&id=0e222e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e222e98",
  null
  
)

export default component.exports